export class AuctionsConstants {
  public static AUCTION: string = 'campaign'
}
